import { Home, Map, Image } from 'lucide-react';
import { SidebarNavLink } from './SidebarNavLink';
import { useLocation } from 'react-router-dom';

export const SidebarNav = () => {
  const location = useLocation();

  return (
    <nav className="flex-1 p-4">
      <div className="space-y-1">
        <SidebarNavLink
          to="/dashboard"
          icon={<Home className="h-5 w-5" />}
          label="Home"
          active={location.pathname === '/dashboard'}
        />
        <SidebarNavLink
          to="/dashboard/field-mapping"
          icon={<Map className="h-5 w-5" />}
          label="Field Mappings"
          active={location.pathname === '/dashboard/field-mapping'}
        />
        <SidebarNavLink
          to="/dashboard/logo"
          icon={<Image className="h-5 w-5" />}
          label="Logo Settings"
          active={location.pathname === '/dashboard/logo'}
        />
      </div>
    </nav>
  );
};
